import { Component } from "react";
import { connect } from "react-redux";
import { GET_DETAILDATA } from "../../actions";
import api from "../../utils/axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiUrl, downloadUrl } from "../Settings/Config";
import { encodeValue, showLoader, hideLoader, showAlert, isLoggedIn, redirectToLogin } from "../Settings/Settings";
import { format } from "date-fns";
import logo from "../../assets/images/brand/nautilusshipping.jpeg";
import otherpracticalExp from "./evaluation.json";
import "../../common/css/evaluvation.css";
const module = "candidate";
const practicalSkills = [{ name: 'psInput1', label: 'Number of Contracts in Ranks' }, { name: 'psInput2', label: 'Type or size of the vessels served (Mention TEU for containers)' }, { name: 'psInput3', label: 'Last contract sign off date' }, { name: 'psInput4', label: 'Type of main engine exp.' }, { name: 'psInput5', label: 'Type of AUX engine exp.' }, { name: 'psInput6', label: 'Cargo cranes/gear (marker) exp.' }, { name: 'psInput7', label: 'Type of Cargo carried' }, { name: 'psInput8', label: 'Type of Cargo pumps(tankers)' }, { name: 'psInput9', label: 'Trading Area(limited/WW)' }, { name: 'psInput10', label: 'Mixed crew (nationalities) exp.' }, { name: 'psInput11', label: 'ECDIS experience in previous 12 months' }, { name: 'psInput12', label: 'PSC experience' }, { name: 'psInput13', label: 'SIRE/CID experience' }];

const evaluationTypeList = [
  { label: 'OFF 47B ENGINE OFFICERS EVALUATION FORM', value: 1, evltype: 'Officers Engine', formno: '47B', title: 'OFFICERS - ENGINE' },
  { label: 'OFF 47A DECK OFFICERS EVALUATION FORM', value: 2, evltype: 'Officers Deck', formno: '47A', title: 'OFFICERS - DECK' },
  { label: 'OFF 47C EVALUTAION FORM DECK RATINGS', value: 3, evltype: 'Engine Officers', formno: '47C', title: 'RATINGS - DECK' },
  { label: 'OFF 47D EVALUATION FORM ENGINE RATINGS', value: 4, evltype: 'Engine Ratings', formno: '47D', title: 'RATINGS - ENGINE' },
  { label: 'OFF 47E GALLEY EVALUATION FORM', value: 5, evltype: 'Galley Officers', formno: '47E', title: 'RATINGS - GALLEY' }
]

class Form extends Component {
  constructor(props) {
    super(props);
    const candidateID = this.props.match.params?.candidateID ?? "";
    const params = new URLSearchParams(this.props.location.search);
    const appliedRank = params.get("appliedRank") || ''
    const appliedFor = params.get("appliedFor") || ''
    const appliedType = params.get("appliedType") || ''

    const viewid = params.get("id") || ''
    console.log(appliedType, 'appliedType')
    const selectedevaluationType = (appliedType !== "") ? evaluationTypeList.find(item => item.value.toString() === appliedType) : '';
    console.log(otherpracticalExp, selectedevaluationType, 'selectedevaluationTypeselectedevaluationType')
    this.state = {
      candidateID,
      viewid,
      appliedRank,
      appliedFor,
      appliedType,
      selectedevaluationType,
      pageloading: true,
      detaildata: [],
      candidateDetails: "",
      photoUrl: "",
      telephone: "",
      mobile: "",
      qualification: "",
      englishLevel: "",
      englishLevelError: false,
      bmi: "",
      drinkingHabits: "",
      drinkingHabitsError: false,
      medicalIssues: "",
      medicalIssuesError: false,
      leavingLast: "",
      leavingLastError: false,
      commentsInt: "",
      commentsIntError: false,
      acceptType: "",
      acceptTypeError: false,
      grading: "",
      gradingError: false,
      dateNow: new Date(),
      practicalSkills,
      otherpracticalExp,
      evaluvartionDate: new Date()

    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    if (!isLoggedIn()) {
      redirectToLogin(this.props.history, this.props.location);
      return;
    }
    if (this.state.candidateID !== "") {
      const params = {
        params: "",
        url: `${module}/detail/${encodeValue(this.state.candidateID)}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
    if (this.state.viewid !== "") {
      api
        .get(`candidateevaluation/detail/${encodeValue(this.state.viewid)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            const result = res.data.result;
            console.log(result, 'resultresultresultresult')
            const appliedType = evaluationTypeList.find(item => item.evltype === result.eval_type);
            const evalvData = result?.values || '';
            console.log(typeof evalvData, evalvData, 'evalvDataevalvDataevalvData')
            const evalvData_ = (evalvData !== "" && evalvData !== null) ? ((typeof evalvData==='object')?evalvData:JSON.parse(evalvData)) : '';
            console.log(evalvData_, 'evalvData_evalvData_')
            const existpracticalSkills = evalvData_?.practicalSkills || [];
            const updatedpracticalSkills = practicalSkills.map(item => {
              const match = existpracticalSkills.find(x => x.name === item.name);
              return match
                ? { ...item, value: match.value }
                : item;
            });
            const appliedType_ = parseInt(appliedType?.value || '');
            const existotherpracticalExp = evalvData_?.otherpracticalExp || [];
            let otherpracticalExp__ = this.state.otherpracticalExp
            const updatedotherpracticalExp = (otherpracticalExp__[appliedType_] || []).map(item => {
              const match = existotherpracticalExp.find(x => x.name === item.name);
              return match
                ? { ...item, value: match.value }
                : item;
            });
            otherpracticalExp__[appliedType_] = updatedotherpracticalExp;
            console.log(evalvData_?.dateNow, 'evalvData_?.dateNowevalvData_?.dateNow')
            this.setState({
              appliedType: appliedType_,
              appliedRank:(result.applied_rank!=="" && result.applied_rank!==null)?result.applied_rank:'',
              selectedevaluationType: appliedType, practicalSkills: updatedpracticalSkills, otherpracticalExp: otherpracticalExp__, englishLevel: evalvData_?.englishLevel || '',
              drinkingHabits: evalvData_?.drinkingHabits || '',
              medicalIssues: evalvData_?.medicalIssues || '',
              leavingLast: evalvData_?.leavingLast || '',
              commentsInt: evalvData_?.commentsInt || '',
              acceptType: evalvData_?.acceptType || '',
              grading: evalvData_?.grading ? { label: evalvData_?.grading, value: evalvData_?.grading } : '',
              dateNow: new Date(evalvData_?.dateNow),
              evaluvartionDate: new Date(evalvData_?.dateNow),
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.candidateID !== "") {
      this.setState({ detaildata: nextProps.detaildata, pageloading: false }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;
          const height_ = result?.height || 0;
          const weight_ = result?.weight || 0;
          let bmi = '';
          if (parseFloat(height_) > 0 && parseFloat(weight_) > 0) {
            bmi = parseFloat(weight_) / parseFloat(height_);
          }

          this.setState({ candidateDetails: result, bmi }, () => {
            this.checkImages()
          });
        }
      });
    }
  }
  checkImages() {
    const photos = this.state.candidateDetails.photos ? `${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}` : null;
    if (photos !== "" && photos !== null) {
      fetch(`${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}`, {
        method: "HEAD",
      })
        .then((res) => {
          if (res.ok) {
            this.setState({ photoUrl: `${downloadUrl}views/public/files/photos/${this.state.candidateDetails.photos}` });
          } else {
          }
        })
        .catch(() => {
          console.log("❌ Error — server unreachable or CORS blocked");
        });
    }
  }

  handleChangeText(event) {
    if (this.state.viewid === "") {
      const name = event.target.name;
      const value = event.target.value;
      if (name === 'c_tel1' || name === 'c_mobi1' || name === 'qualifications') {
        this.setState((prev) => ({
          candidateDetails: {
            ...prev.candidateDetails,
            c_tel1: value
          }
        }));
      }
      this.setState({ [name]: value, [`${name}Error`]: false });
    }
  }
  handleSelectChange(name, value) {
    if (this.state.viewid === "") {
      this.setState({ [name]: value, [`${name}Error`]: false });
    }
  }
  handleChangePSkill(keyIndex, event) {
    if (this.state.viewid === "") {
      const value = event.target.value;
      const practicalSkills = this.state.practicalSkills.map((item, index) => {
        if (keyIndex === index) {
          item.value = value
          delete item.error
        }
        return item;
      })
      this.setState({ practicalSkills })
    }
  }
  handleChangeOPSkill(keyIndex, value) {
    if (this.state.viewid === "") {
      const otherpracticalExp = { ...this.state.otherpracticalExp };
      otherpracticalExp[this.state.appliedType][keyIndex].value = value;
      delete otherpracticalExp[this.state.appliedType][keyIndex].error;
      this.setState({ otherpracticalExp });
    }
  }

  submitForm() {
    let error = 0;
    let finalpracticalSkills = [];

    const practicalSkills_ = this.state.practicalSkills.map((item) => {
      const value = item?.value || '';
      if (value !== "") {
        finalpracticalSkills.push({ name: item.name, value })
      } else {
        item.error = true
        error++;
      }
      return item;
    })
    this.setState({ practicalSkills: practicalSkills_ })
    let finalotherpracticalExp = [];

    const otherpracticalExp_ = otherpracticalExp[this.state.appliedType].map((item) => {
      const value = item?.value || '';
      if (value !== "") {
        finalotherpracticalExp.push({ name: item.name, value })
      } else {
        item.error = true
        error++;
      }
      return item;
    })
    let otherpracticalExp__ = this.state.otherpracticalExp;
    otherpracticalExp__[this.state.appliedType.toString()] = otherpracticalExp_;
    this.setState({ otherpracticalExp: otherpracticalExp__ })
    if (this.state.englishLevel === "") {
      this.setState({ englishLevelError: true })
      error++;
    }
    if (this.state.drinkingHabits === "") {
      this.setState({ drinkingHabitsError: true })
      error++;
    }
    if (this.state.medicalIssues === "") {
      this.setState({ medicalIssuesError: true })
      error++;
    }
    if (this.state.commentsInt === "") {
      this.setState({ commentsIntError: true })
      error++;
    }
    if (this.state.leavingLast === "") {
      this.setState({ leavingLastError: true })
      error++;
    }
    if (this.state.acceptType === "") {
      this.setState({ acceptTypeError: true })
      error++;
    }
    if (this.state.grading === "") {
      this.setState({ gradingError: true })
      error++;
    }


    if (error === 0) {
      const postObject = {
        candidateID: this.state.candidateID,
        c_tel1: this.state.candidateDetails.c_tel1,
        c_mobi1: this.state.candidateDetails.c_mobi1,
        qualifications: this.state.candidateDetails.qualifications,
        appliedRank: this.state.appliedRank,
        appliedFor: this.state.appliedFor,
        appliedType: this.state.appliedType,
        evalucateData: JSON.stringify({
          englishLevel: this.state.englishLevel,
          bmi: this.state.bmi,
          drinkingHabits: this.state.drinkingHabits,
          medicalIssues: this.state.medicalIssues,
          leavingLast: this.state.leavingLast,
          commentsInt: this.state.commentsInt,
          acceptType: this.state.acceptType,
          grading: this.state.grading?.label,
          dateNow: new Date(),
          practicalSkills: finalpracticalSkills,
          otherpracticalExp: finalotherpracticalExp
        })
      };
      showLoader("saveDiscussion");
      /* ${encodeValue(this.state.evaluationID)} */
      const post_url = `candidateevaluation`;

      api
        .put(post_url, postObject)
        .then((res) => {
          hideLoader("saveDiscussion");
          const errMsg = res.data.message;
          if (res.data.status === "ok") {
            showAlert("Success", errMsg, "success", "No");
          } else {
            showAlert("Error", errMsg, "error", "No");
          }
        })
        .catch((err) => {
          hideLoader("saveDiscussion");
          const errMsg = err.response.data?.message || err?.message;
          showAlert("Error", errMsg, "error", "No");
          console.error(err);
        });
    } else {
      setTimeout(() => {
        const el = document.getElementsByClassName("text-danger")[0];
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }, 1000);

    }
  }

  /* printEvaluation() {
    window.location.href
  } */

  render() {
    const cDetails = this.state.candidateDetails;
    const cName = `${cDetails?.fname || ''} ${cDetails?.lname || ''}`
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <div className="container evaluation-form mt-4">
              <div className="card shadow-sm mb-4">
                <div className="card-body header-section">
                  <div className="row align-items-center">
                    <div className="col-md-2">
                      <img src={logo} alt="NS-Nemo" />
                    </div>
                    <div className="col-md-7">
                      <h2 className="title align-items-center" style={{ textAlign: 'center' }}>PRE-EMPLOYMENT EVALUATION SHEET<br />{this.state.selectedevaluationType?.title}</h2>
                    </div>

                    <div className="col-md-3 text-end">
                      <div className="photo-box" style={{ width: '100%' }}>
                        FORM NO: OFF {this.state.selectedevaluationType?.formno}<br />
                        RPSL Number : RPSL-CHN-012<br />
                        REVISION NO: 00<br />
                        DATE: {(this.state.evaluvartionDate!=="" && this.state.evaluvartionDate!==null)?format(this.state.evaluvartionDate, 'dd/MMM/yyyy'):''}<br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card shadow-sm mb-4">
                <div className="card-header section-title">
                  Candidate Information
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-10">
                      <div className="form-row g-3">

                        <div className="col-md-6 form-group">
                          <label className="form-label">Family Name & Given Name</label>
                          <input className="form-control" name="fullName" value={cName} readOnly />
                        </div>

                        <div className="col-md-3 form-group">
                          <label className="form-label">Nationality</label>
                          <input className="form-control" name="nationality" defaultValue={cDetails?.nationalityName} readOnly />
                        </div>

                        <div className="col-md-3 form-group">
                          <label className="form-label">Telephone</label>
                          <input className="form-control" name="c_tel1" value={cDetails?.c_tel1 || ''} onChange={this.handleChangeText} />
                        </div>

                        <div className="col-md-3 form-group">
                          <label className="form-label">Rank Applied</label>
                          <input className="form-control" name="rankApplied" defaultValue={this.state.appliedRank} readOnly />
                        </div>

                        <div className="col-md-3 form-group">
                          <label className="form-label">Mobile</label>
                          <input className="form-control" name="c_mobi1" value={cDetails?.c_mobi1} onChange={this.handleChangeText} />
                        </div>

                        <div className="col-md-3 form-group">
                         <label className="form-label">Qualification</label>
                          <input className="form-control" name="qualifications" value={cDetails?.qualifications} onChange={this.handleChangeText} />
                        </div>

                        <div className="col-md-3 form-group">
                          <label className="form-label">Last Contract Position</label>
                          <input className="form-control" name="lastContract" defaultValue={cDetails?.c_rank} readOnly />
                        </div>

                      </div>
                    </div>
                    <div className="col-md-2 text-end">
                      <div className="photo-box">
                        {this.state.photoUrl !== "" ? <img src={this.state.photoUrl} alt={cName} style={{ width: '100%', height: '100%' }} /> : `Candidate Photo`}

                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="form-row">
                    <div className="col-md-5">
                      <div className="form-group">
                        <div className="form-label">Communication</div>
                        <div className={`d-flex gap-4 ${this.state.englishLevelError ? 'text-danger' : ''}`}>
                          <label className="custom-control custom-radio d-flex align-items-center">
                            <input type="radio" className="custom-control-input me-2" name="englishLevel" value="good" onChange={this.handleChangeText} checked={this.state.englishLevel === 'good' ? true : false} />
                            <span className="custom-control-label">Good</span>
                          </label>

                          <label className="custom-control custom-radio d-flex align-items-center">
                            <input type="radio" className="custom-control-input me-2" name="englishLevel" value="satisfactory" onChange={this.handleChangeText} checked={this.state.englishLevel === 'satisfactory' ? true : false} />
                            <span className="custom-control-label">Satisfactory</span>
                          </label>

                          <label className="custom-control custom-radio d-flex align-items-center">
                            <input type="radio" className="custom-control-input me-2" name="englishLevel" value="poor" onChange={this.handleChangeText} checked={this.state.englishLevel === 'poor' ? true : false} />
                            <span className="custom-control-label">Poor</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 form-group">
                      <label className="form-label">BMI</label>
                      <input className="form-control" name="bmi" defaultValue={this.state.bmi} readOnly />
                    </div>
                    <div className="col-md-5">
                      <div className="row">
                        <div className="col-md-6">
                          <div className={`form-group ${this.state.drinkingHabitsError ? 'text-danger' : ''}`}>
                            <div className="form-label">Drinking Habits</div>
                            <div className="d-flex gap-4">
                              <label className="custom-control custom-radio d-flex align-items-center">
                                <input type="radio" className="custom-control-input me-2" name="drinkingHabits" value="Yes" onChange={this.handleChangeText} checked={this.state.drinkingHabits === 'Yes' ? true : false} />
                                <span className="custom-control-label">Yes</span>
                              </label>
                              <label className="custom-control custom-radio d-flex align-items-center">
                                <input type="radio" className="custom-control-input me-2" name="drinkingHabits" value="No" onChange={this.handleChangeText} checked={this.state.drinkingHabits === 'No' ? true : false} />
                                <span className="custom-control-label">No</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className={`form-group ${this.state.medicalIssuesError ? 'text-danger' : ''}`}>
                            <div className="form-label">Any Medical issues</div>
                            <div className="d-flex gap-4">
                              <label className="custom-control custom-radio d-flex align-items-center">
                                <input type="radio" className="custom-control-input me-2" name="medicalIssues" value="Yes" onChange={this.handleChangeText} checked={this.state.medicalIssues === 'Yes' ? true : false} />
                                <span className="custom-control-label">Yes</span>
                              </label>
                              <label className="custom-control custom-radio d-flex align-items-center">
                                <input type="radio" className="custom-control-input me-2" name="medicalIssues" value="No" onChange={this.handleChangeText} checked={this.state.medicalIssues === 'No' ? true : false} />
                                <span className="custom-control-label">No</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card shadow-sm mb-4">
                <div className="card-header section-title-blue">
                  PRACTICAL SKILLS
                </div>
                <div className="card-body">
                  <div className="form-row g-3">
                    {this.state.practicalSkills.map((item, index) => {
                      return (
                        <div className={`form-group col-md-6 ${item?.error === true ? 'text-danger' : ''}`} key={index}>
                          <label className="form-label">{item.label}</label>
                          <input className="form-control" name={item.name} value={item?.value || ''} onChange={this.handleChangePSkill.bind(this, index)} />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              <div className="card shadow-sm mb-4">
                <div className="card-header section-title-blue">
                  OTHER PRACTICAL EXPERIENCE (Tick the appropriate box)
                </div>
                <div className="card-body">
                  <div className="row">
                  { console.log(this.state.otherpracticalExp[this.state.appliedType] || [], 'checkingaaaaa')}
                    {(this.state.otherpracticalExp[this.state.appliedType] || []).map((item, index) => {
                      return (
                        <div className={`col-md-6 ${item?.error === true ? 'text-danger' : ''}`} key={index}>
                          <div className="form-group" style={{ marginBottom: '0' }}>
                            <div className="form-label">{item.label}</div>
                            <div className="d-flex gap-4">
                              <label className="custom-control custom-radio d-flex align-items-center">
                                <input type="radio" className="custom-control-input me-2" name={item.name} value="yes" onChange={this.handleChangeOPSkill.bind(this, index, 'yes')} checked={item?.value === 'yes' ? true : false} />
                                <span className="custom-control-label">Yes</span>
                              </label>
                              <label className="custom-control custom-radio d-flex align-items-center">
                                <input type="radio" className="custom-control-input me-2" name={item.name} value="no" onChange={this.handleChangeOPSkill.bind(this, index, 'no')} checked={item?.value === 'no' ? true : false} />
                                <span className="custom-control-label">No</span>
                              </label>
                              <label className="custom-control custom-radio d-flex align-items-center">
                                <input type="radio" className="custom-control-input me-2" name={item.name} value="n/a" onChange={this.handleChangeOPSkill.bind(this, index, 'n/a')} checked={item?.value === 'n/a' ? true : false} />
                                <span className="custom-control-label">N/A</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              <div className="card shadow-sm mb-4">
                <div className="card-body">
                  <div className="form-row g-3">
                    <div className={`col-md-12 form-group ${this.state.leavingLastError ? 'text-danger' : ''}`}>
                      <label className="form-label">Last Employer – Reason for Leaving</label>
                      <textarea className="form-control mb-3" rows="2" name="leavingLast" onChange={this.handleChangeText} value={this.state.leavingLast}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card shadow-sm mb-4">
                <div className="card-header section-title-danger">
                  INTERVIEWER COMMENTS
                </div>
                <div className="card-body">
                  <textarea className={`form-control mb-3 ${this.state.commentsIntError ? 'text-danger' : ''}`} rows="4" name="commentsInt" onChange={this.handleChangeText} value={this.state.commentsInt}></textarea>
                  <div className="row">
                    <div className="col-md-6">
                      <div className={`form-group mt-4 ${this.state.acceptTypeError ? 'text-danger' : ''}`}>
                        <div className="d-flex gap-4">
                          <label className="custom-control custom-radio d-flex align-items-center">
                            <input type="radio" className="custom-control-input me-2" name="acceptType" value="accepted" onChange={this.handleChangeText} checked={this.state.acceptType === 'accepted' ? true : false} />
                            <span className="custom-control-label">Accepted</span>
                          </label>

                          <label className="custom-control custom-radio d-flex align-items-center">
                            <input type="radio" className="custom-control-input me-2" name="acceptType" value="rejected" onChange={this.handleChangeText} checked={this.state.acceptType === 'rejected' ? true : false} />
                            <span className="custom-control-label">Rejected</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-3 ${this.state.gradingError ? 'text-danger' : ''}`}>
                      <label className="form-label">Grading</label>
                      <Select value={this.state.grading} onChange={this.handleSelectChange.bind(this, "grading")} placeholder="Select Grading" isClearable={true} options={[{ label: 'Excellent', value: 'Excellent' }, { label: 'Satisfactory', value: 'Satisfactory' }, { label: 'Poor', value: 'Poor' }]} />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Date</label>
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select Date"
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                        selected={this.state.dateNow}
                        dateFormat="dd-MM-yyyy"
                        onChange={this.handleSelectChange.bind(this, "dateNow")}
                        isClearable={false}
                      />
                    </div>
                  </div>
                  <div className="alert alert-warning mt-3">
                    Kindly double-check before submitting! Once submitted the form cannot be edited again.
                  </div>
                  {this.state.viewid === "" ? (
                    <button className="btn btn-success submit-btn" onClick={this.submitForm.bind(this)}>
                      Submit Evaluation for Candidate
                    </button>):(
                       <a href={`${apiUrl}cevaluation/downloadEvaluvation/${encodeValue(this.state.viewid)}`} target="_blank"><button type="button" className="btn btn-success submit-btn" >
                      Print 
                    </button></a>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);